module.exports = __webpack_public_path__ + "img/bannerog.c76f0847.webp";